import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    this.collapsed = true
  }

  onToggleMenu() {
    if (this.collapsed) {
      this.element.classList.add("min-w-[220px]")
      this.element.classList.remove("min-w-[60px]")
      this.collapsed = false
    } else {
      this.element.classList.remove("min-w-[220px]")
      this.element.classList.add("min-w-[60px]")
      this.collapsed = true
    }
  }
}